import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
}

export function Card({ title, subtitle, action, className = '', children, ...props }: CardProps) {
  return (
    <section
      className={['card', 'w-full', className].filter(Boolean).join(' ')}
      {...props}
    >
      {(title || subtitle || action) && (
        <header className="mb-2 flex items-center justify-between gap-2">
          <div>
            {title && <h2 className="text-sm font-semibold text-gray-900">{title}</h2>}
            {subtitle && (
              <p className="mt-0.5 text-xs text-gray-500">
                {subtitle}
              </p>
            )}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </header>
      )}
      {children}
    </section>
  );
}


